<div class="profile">
  <div class="hidden lg:block">
    <div class="mb-6 flex items-center">
      <div class="mr-4 h-1 w-6 bg-primary-md-dark lg:w-12"></div>
      <div class="text-xl font-medium text-primary-darkest lg:text-3xl">
        Skin Fit
      </div>
    </div>
  </div>
  <div class="content">
    <div *ngIf="!loadSkinFit && skinFits.length > 0">
      <div
        class="skin-fit skin-fit-latest mb-3 pb-10"
        *ngIf="!loadSkinFit && skinFits.length > 1">
        <div
          class="skin-fit-body border p-5"
          [ngClass]="
            isLatestSkinFitContentSelected ? ' border-yellow-700' : ''
          ">
          <div class="last-update pb-5 text-center md:text-right">
            <span
              class="inline-block rounded-md bg-primary-darkest py-1 px-3 text-sm text-white"
              >Latest :
              {{ skinFits[0].updated_at | date: 'dd MMM yyyy h:mm a' }}</span
            >
          </div>
          <div class="skin-fit-detail">
            <div class="mx-0 grid lg:grid-cols-12">
              <div class="py-3 text-center lg:col-span-3">
                <img
                  class="mx-auto h-[200px] w-[150px] flex-none border-2 border-primary-md-dark bg-white"
                  style="
                    width: 150px;
                    height: 200px;
                    object-fit: cover;
                    border-radius: 8px;
                  "
                  src="{{ skinFits[0].file_path }}"
                  alt="" />
              </div>
              <div
                class="skin-problems latest m-0 grid grid-cols-2 gap-3 md:grid-cols-4 lg:col-span-9">
                <div
                  class="skin-problem rounded-lg p-2 hover:bg-gray-50"
                  *ngFor="
                    let latestSkinFitContent of latestSkinFitContents;
                    let i = index
                  "
                  (click)="selectFaceAnalization(i)">
                  <div
                    class="skin-pict mb-2"
                    *ngIf="latestSkinFitContent.image">
                    <div>
                      <img
                        class="mx-auto"
                        [ngClass]="
                          !latestSkinFitContent.status ? 'grayscale' : ''
                        "
                        src="{{ latestSkinFitContent.image }}"
                        style="width: 70px; height: 70px"
                        alt="" />
                    </div>
                  </div>
                  <div
                    class="skin-pict mb-2"
                    *ngIf="!latestSkinFitContent.image">
                    <div
                      class="mx-auto"
                      [style]="
                        'width:  70px; height:  70px; background-color: #' +
                        latestSkinFitContent.colour +
                        '; border-radius: 14px;'
                      "></div>
                  </div>
                  <div class="text-center">
                    <span>{{ latestSkinFitContent.name }}</span>
                  </div>
                  <p
                    *ngIf="!latestSkinFitContent.colour"
                    class="fs-18 mt-2 mb-0 text-center"
                    style="font-weight: 600">
                    {{
                      latestSkinFitContent.status
                        ? (latestSkinFitContent.confidence | number: '1.0-0')
                        : (1 | number: '1.0-0')
                    }}
                    %
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="skin-fit-history mx-0 grid bg-primary-light lg:grid-cols-12">
        <div
          class="skin-fit-list col-span-3 hidden bg-primary-dark px-2 py-4 lg:block">
          <div class="skin-fit-list-head mb-5">
            <h3
              class="txt-p-darkest fs-16 text-uppercase text-center font-bold text-primary-darkest">
              Skin Fit History
            </h3>
          </div>
          <div class="skin-fit-list-body">
            <div class="list-date max-h-[515px] overflow-y-auto">
              <div
                class="date mb-1 p-2"
                *ngFor="let skinFit of skinFits; let i = index"
                [ngClass]="
                  skinFit.id == selectedSkinFit.id
                    ? 'rounded-lg bg-white p-2 shadow-md'
                    : ''
                "
                (click)="selectSkinFitByIndex(i)">
                <div class="text-center">
                  {{
                    i == 0
                      ? 'Latest'
                      : (skinFit.created_at | date: 'dd MMM yyyy h:mm a')
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="skin-fit col-span-9 p-0">
          <div class="skin-fit-body p-10 lg:p-5" *ngIf="selectedSkinFitContent">
            <div class="w-100 py-3 text-center lg:hidden">
              <h3
                class="txt-p-darkest text-uppercase text-center text-lg font-bold text-primary-darkest">
                Skin Fit History
              </h3>
              <div class="p-select-wrapper my-4">
                <select
                  class="p-form-control rounded-lg bg-primary-dark p-2"
                  (change)="selectSkinFitByEvent($event)">
                  <option
                    *ngFor="let skinFit of skinFits; let i = index"
                    [value]="i"
                    [disabled]="i == 0"
                    [selected]="i == 1">
                    {{
                      i == 0
                        ? 'Latest'
                        : (skinFit.created_at | date: 'dd MMM yyyy h:mm a')
                    }}
                  </option>
                </select>
              </div>
            </div>
            <div class="skin-fit-detail">
              <div class="skin-info m-0 grid pb-10 lg:grid-cols-12 lg:px-4">
                <div class="skin-pict py-3 text-center lg:col-span-4 lg:py-0">
                  <img
                    class="mx-auto h-[200px] w-[150px] flex-none rounded-full border-2 border-primary-md-dark bg-white"
                    style="object-fit: cover; border-radius: 8px"
                    src="{{ selectedSkinFit.file_path }}"
                    alt="" />
                </div>
                <div class="skin-description lg:col-span-8">
                  <h3
                    class="mb-2 text-4xl font-bold uppercase text-primary-md-dark">
                    {{ selectedSkinFitContent.name }}
                  </h3>
                  <p class="text-lg">
                    {{ selectedSkinFitContent.description }}
                  </p>
                </div>
              </div>
              <div
                class="skin-problems m-0 grid grid-cols-2 gap-3 md:grid-cols-4">
                <div
                  class="skin-problem"
                  *ngFor="let skinFitContent of skinFitContents; let i = index"
                  [ngClass]="{
                    'rounded-lg bg-white p-2 shadow-md': skinFitContent.isActive
                  }"
                  (click)="selectFaceAnalization(i)">
                  <div class="skin-pict mb-2" *ngIf="skinFitContent.image">
                    <div>
                      <img
                        class="mx-auto"
                        [ngClass]="!skinFitContent.status ? 'grayscale' : ''"
                        src="{{ skinFitContent.image }}"
                        style="width: 70px; height: 70px"
                        alt="" />
                    </div>
                  </div>
                  <div class="skin-pict mb-2" *ngIf="!skinFitContent.image">
                    <div
                      class="mx-auto"
                      [style]="
                        'width:  70px; height:  70px; background-color: #' +
                        skinFitContent.colour +
                        '; border-radius: 14px;'
                      "></div>
                  </div>
                  <div class="text-center">
                    <span>{{ skinFitContent.name }}</span>
                  </div>
                  <p
                    *ngIf="!skinFitContent.colour"
                    class="fs-18 mt-2 mb-0 text-center"
                    [ngClass]="skinFitContent.isActive ? 'txt-p-md-dark' : ''"
                    style="font-weight: 600">
                    {{
                      skinFitContent.status
                        ? (skinFitContent.confidence | number: '1.0-0')
                        : (1 | number: '1.0-0')
                    }}
                    %
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" *ngIf="!loadSkinFit && isSkinFitError">
      <img
        class="mx-auto mb-3"
        src="assets/images/load-error.svg"
        alt="empty cart"
        srcset=""
        style="max-width: 250px" />
      <p>Something wrong, Cannot Find Your Skin Fits</p>
      <button class="btn-p-md-dark" (click)="setSkinFit()">Retry</button>
    </div>
    <div class="loading text-center" *ngIf="loadSkinFit">
      <fa-icon class="load-icon" [icon]="faSpinner" [spin]="true"></fa-icon>
    </div>
  </div>
</div>
